import { Button } from "@mui/material";
import TabPanel from "../TabPanel";
import { SettingsModalTabProps } from "../types";
import { useContext, useState } from "react";
import CreateTagsModal from "./CreateTagsModal";
import { useQuery } from "@apollo/client/react";
import { EssealDataTable } from "esseal-data-table";
import tagsColumns from "./tagsColumns";
import CurrentUserContext from "@/Contexts/CurrentUser";
import { GetCompanyTagsDocument, CompanyTag } from "@/graphql/generated/graphql";

const TagsManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index, showHeading }) => {
  const { currentUser } = useContext(CurrentUserContext);
  const [open, setOpen] = useState(false);
  const { data, loading } = useQuery(GetCompanyTagsDocument, {
    skip: !currentUser?.defaultCompany?.id,
  });

  if (!data) return <></>;

  return (
    <TabPanel value={parentTab} index={index} heading="Tag Management" showHeading={showHeading}>
      <EssealDataTable
        rows={data?.getCompanyTags as CompanyTag[] ?? []}
        columns={tagsColumns}
        loading={loading}
        checkboxSelection={false}
        pagination={true}
        pageSize={25}

        toolbar={
          <Button
            onClick={() => setOpen(true)}
          >
            + New Tag
          </Button>
        }
      />

      {open && <CreateTagsModal handleClose={() => setOpen(false)} />}
    </TabPanel>
  )
};

export default TagsManagementTab;
